import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay?: number | null): void => {
    const savedCallback = useRef<() => Record<string, unknown>>();

    useEffect(() => {
        // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
        savedCallback.current = callback as any;
    }, [callback]);

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null && delay !== undefined) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
};
